import { useTeams } from '../../../../../hooks/useTeams';
import { useCompanies } from '../../../../../hooks/useCompanies';
import {
	AUTHENTICATION_PROVIDER,
	AuthType,
	CompanySettings,
	Team,
} from '../../../../../types';

interface TenantPickerListItem {
	name: string;
	id: string;
}

const mapCompanySettingsToListItem = (company: CompanySettings) => ({
	name: company.organizationName || company.organization || '',
	id: company.organization || '',
});

const mapTeamsToListItem = (team: Team) => ({
	name: team.teamName || team.tenantId || '',
	id: team.tenantId || '',
});

const filterEmptyListItems = (item: TenantPickerListItem) => item.id;

/**
 * Only returns the tenantPicker menu items - excludes the active one
 */
export const useTenantPickerListItems = () => {
	const { alternateTeams } = useTeams();
	const { alternateCompanies } = useCompanies();
	// TODO figure out a better way to verify this value
	const isAuth0 =
		localStorage.getItem(AUTHENTICATION_PROVIDER) == AuthType.Auth0;

	let tenantPickerListItems: TenantPickerListItem[] = [];

	// Auth0 uses company settings
	if (isAuth0 && alternateCompanies) {
		tenantPickerListItems = alternateCompanies.map(
			mapCompanySettingsToListItem,
		);
	}
	// Forge uses teams unless the project picker is on
	else if (!isAuth0 && alternateTeams) {
		tenantPickerListItems = alternateTeams.map(mapTeamsToListItem);
	}

	return tenantPickerListItems.filter(filterEmptyListItems);
};

export const useTenantPickerText = () => {
	const { activeTeam } = useTeams();
	const { activeCompany } = useCompanies();

	const isAuth0 =
		localStorage.getItem(AUTHENTICATION_PROVIDER) == AuthType.Auth0;

	let text = '';

	// Auth0 uses company settings
	if (isAuth0 && activeCompany) {
		text =
			activeCompany.organizationName || activeCompany.organization || '';
	}
	// Forge uses teams unless the project picker is on
	else if (!isAuth0 && activeTeam) {
		text = activeTeam.teamName || activeTeam.tenantId || '';
	}

	return text;
};
